const getBrandUTMType = ({ brand, upsell = false } = {}) => {
	if (!brand) return "";
	const { metadata: eventMetadata = {} } = brand;
	return upsell
		? "upsell"
		: "premium";
};

export default getBrandUTMType;
